import React from 'react';
import slugify from 'slugify';
import { useStaticQuery, graphql } from 'gatsby';
import Layout from '../Layout';
import PageHeader from 'gatsby-theme-carbon/src/components/PageHeader';
// import NextPrevious from 'gatsby-theme-carbon/src/components/NextPrevious';
import PageTabs from '../../../components/PageTabs/PageTabs';
import { useMetadata } from 'gatsby-theme-carbon/src/util/hooks';
import Main from 'gatsby-theme-carbon/src/components/Main';
import { Helmet } from 'react-helmet';
import LastModifiedDate from 'gatsby-theme-carbon/src/components/LastModifiedDate';
import './DefaultCL.scss'

const Default = ({ pageContext, children, location, Title }) => {
  const { interiorTheme } = useMetadata();
  
 // get the path prefix if it exists
 const {
  site: { pathPrefix },
} = useStaticQuery(graphql`
  query PATH_PREFIX_QUERY {
    site {
      pathPrefix
    }
  }
`);
  if (!pageContext) {
      return <React.Fragment>{children}</React.Fragment>;

  }
  

  const { frontmatter = {},  titleType } = pageContext;

  const {
    tabs,
    title,
    theme: frontmatterTheme,
    description,
    keywords,
    date,
    noIndex
  } = frontmatter;

  if (frontmatter.redirect) {
    setTimeout(() => {
        if (typeof document !== "undefined") {
            document.location.href = frontmatter.redirect
        }
    },1);
    return <React.Fragment></React.Fragment>
}
 

  // let gatsby handle prefixing
  const slug = pathPrefix
    ? location.pathname.replace(pathPrefix, '')
    : location.pathname;

  const getCurrentTab = () => {
    if (!tabs) return '';
    return (
      slug.split('/').filter(Boolean).slice(-1)[0] ||
      slugify(tabs[0], { lower: true })
    );
  };

  const currentTab = getCurrentTab();

  const theme = frontmatterTheme || interiorTheme;

  return (
    <Layout
      tabs={tabs}
      homepage={false}
      theme={theme}
      pageTitle={title}
      pageDescription={description}
      pageKeywords={keywords}
      titleType={titleType}>
        {typeof window !== "undefined" && !window.location.href.includes("localhost") && <Helmet>
                <script type = "text/javascript">{`
                  window.digitalData = {
                      page: {
                          category: {
                              primaryCategory: 'NO_CATEGORY_ASSIGNED',
                          },
                          pageInfo: {
                              ibm: {
                                  siteID: 'IBM_ACCESSIBILITY',
                              }
                          },
                      }
                  };`}
                </script>
                <script src="//1.www.s81c.com/common/stats/ibm-common.js" type="text/javascript" async="async"></script>
                {noIndex && <meta name="robots" content="noindex" />}
            </Helmet>
            }
      <PageHeader
        title={Title ? <Title /> : title}
        label="label"
        tabs={tabs}
        theme={theme}
      />
      {tabs && (
        <PageTabs
          title={title}
          slug={slug}
          tabs={tabs}
          currentTab={currentTab}
          children={children}
        />
      )}
      {!tabs &&
        <Main padded={"padded"}>
          {children}
          <LastModifiedDate date={date} />
        </Main>
      }
      {/* <NextPrevious
        pageContext={pageContext}
        location={location}
        slug={slug}
        tabs={tabs}
        currentTab={currentTab}
      /> */}
    </Layout>
  );
};

export default Default;
